import { Offering } from '../../types/offerings';
import { OfferingsServiceApiClient } from '@highereducation/offerings';
import { getApiConfig } from '@de/services';
type GetOfferingsParams = {
  subjects: string[];
};

export const getRecommendedOfferings = async (
  params: GetOfferingsParams,
): Promise<Offering[]> => {
  const config = getApiConfig();
  const baseUrl = config.offeringsSearchApiUrl ?? '';
  if (!baseUrl) {
    throw new Error('Offerings base URL is not set');
  }
  try {
    const response = await new OfferingsServiceApiClient({
      baseUrl,
    }).getRecommendations({
      subjects: params.subjects,
    });

    return response.data.courses as Offering[];
  } catch (error) {
    console.error('Get Recommendations failed:', error);
    throw error;
  }
};
